// extracted by mini-css-extract-plugin
export default {"formWrapper":"styles_formWrapper__2UGeL","formGroup":"styles_formGroup__hFlXG","title":"styles_title__lQnu4","bottom":"styles_bottom__JMe-+"};